import { useEffect, useMemo } from "react"

import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router"

import { useQuery } from "../../../Utils/utils"
import UserCreators from "../reducer"

export const useFetchBusinessAccount = () => {
  const { search } = useLocation()
  const query = useQuery(search)
  const inviteId = query.get("invite")

  const dispatch = useDispatch()
  const { inviteInfo } = useSelector((state) => state.setting)
  const { userInfo, isAdmin } = useSelector((state) => state.auth)
  const { businessAccountsWithRole, businessAccount } = useSelector((state) => state.user)

  const isBusinessAccountMatches = useMemo(() => {
    return Boolean(
      businessAccountsWithRole?.find((account) => {
        return account.id === userInfo?.current_business_account_id
      })
    )
  }, [businessAccountsWithRole, userInfo])

  useEffect(() => {
    if (!inviteInfo && !inviteId && isBusinessAccountMatches && !isAdmin) {
      dispatch(UserCreators.getBusinessAccountRequest(userInfo?.current_business_account_id))
    }
  }, [
    inviteInfo,
    userInfo?.current_business_account_id,
    isBusinessAccountMatches,
    inviteId,
    isAdmin,
  ]);

  return businessAccount
}
